// extracted by mini-css-extract-plugin
export default {"gradient2":"styles_gradient2__oU4do","gradient1":"styles_gradient1__Q2dX9"};